export interface HashtagLeaderboardQueryStatus {
	isLoading: boolean;
	isFetching: boolean;
}

export const areHashtagReceiversReady = (hashtags: string[], queries: HashtagLeaderboardQueryStatus[], isLoadingHashtags: boolean): boolean => {
	if (isLoadingHashtags) return false;
	if (hashtags.length === 0) return true;
	if (queries.length !== hashtags.length) return false;
	return queries.every((query) => !query.isLoading && !query.isFetching);
};

export const isFetchingHashtagReceivers = (hashtags: string[], queries: HashtagLeaderboardQueryStatus[], isLoadingHashtags: boolean): boolean => {
	if (isLoadingHashtags) return true;
	if (queries.length !== hashtags.length) return true;
	return queries.some((query) => query.isLoading || query.isFetching);
};
